module.exports = __webpack_public_path__ + "img/list_Story_03.4f5404b6.jpeg";